import { render, staticRenderFns } from "./customer-user-list.vue?vue&type=template&id=a23d2d20&scoped=true&"
import script from "./customer-user-list.vue?vue&type=script&lang=js&"
export * from "./customer-user-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-user-list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customer-user-list.vue?vue&type=style&index=1&id=a23d2d20&scoped=true&lang=css&"
import style2 from "./customer-user-list.vue?vue&type=style&index=2&id=a23d2d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23d2d20",
  null
  
)

export default component.exports